import { useState, useEffect } from 'react';
import { X, Clock } from 'lucide-react';
import { BIANNUAL_DISCOUNT_PERCENT, ANNUAL_DISCOUNT_PERCENT } from '../../utils/discounts';

const DiscountBanner = () => {
  // Toggle this to show/hide the entire banner
  const SHOW_BANNER = false; // Set to false to disable the banner completely
  
  const [isVisible, setIsVisible] = useState(true);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  // Set your launch date here (when discount ends)
  const launchDate = new Date('2025-10-27T00:00:00'); // Example: October 27, 2025

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date().getTime();
      const distance = launchDate.getTime() - now;

      if (distance < 0) {
        return { days: 0, hours: 0, minutes: 0, seconds: 0 };
      }

      return {
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000),
      };
    };

    // Initial calculation
    setTimeLeft(calculateTimeLeft());

    // Update every second
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  // Don't render if banner is disabled or user closed it
  if (!SHOW_BANNER || !isVisible) return null;

  return (
    <div className="relative bg-gradient-to-r from-yellow-500 via-yellow-400 to-yellow-500 text-black z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-center gap-3 py-3 text-center flex-wrap">
          <p className="text-sm md:text-base font-semibold">
            <span className="font-bold">🎉 Early Bird Special:</span> Lock in {BIANNUAL_DISCOUNT_PERCENT}-{ANNUAL_DISCOUNT_PERCENT}% OFF! 
            <span className="hidden sm:inline"> Join Creators Archive.</span>
          </p>
          
          {/* Countdown Timer */}
          <div className="flex items-center gap-2 bg-black/10 px-3 py-1 rounded-full">
            <Clock className="w-3.5 h-3.5" />
            <span className="text-xs md:text-sm font-bold">
              {timeLeft.days}d {timeLeft.hours}h {timeLeft.minutes}m {timeLeft.seconds}s
            </span>
          </div>
          
        </div>
      </div>
      
      {/* Close button */}
      <button
        onClick={() => setIsVisible(false)}
        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 hover:bg-black/10 rounded-full transition-colors"
        aria-label="Close banner"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default DiscountBanner;
